import { ref } from 'vue';

/* Which band is behind the fixed rails.
   The public site alternates light and dark bands, and the two fixed rails
   (the scroll-to-top progress and the language switch) have to invert with the
   band behind them, or they render dark ink on a near-black footer.

   The arithmetic to work that out was copy-pasted into both components, and it
   read the midpoint of the viewport against a running boundary of section
   bottoms. It also threw when the midpoint was past the last section, which is
   where the footer is on a short viewport: that killed the scroll handler, so
   the rail kept the colour of whatever band it was over before. Both rails now
   ask this one function, and the footer is part of the surface set, so the
   answer at the bottom of a page is the footer's own answer rather than a
   frozen stale one. */

/* The band that owns the vertical midpoint of the viewport. Sections are
   stacked, so walking them and comparing the midpoint against each bottom
   finds the one containing it. */
function surfaceAtViewportMidpoint() {
  const midpoint = window.scrollY + window.innerHeight / 2;
  const surfaces = document.querySelectorAll('section, footer');
  let boundary = 0;

  for (let index = 0; index < surfaces.length; index += 1) {
    const bottom = surfaces[index].getBoundingClientRect().bottom + window.scrollY;

    if (midpoint >= boundary && midpoint < bottom) {
      return surfaces[index];
    }

    boundary = bottom;
  }

  /* Above the first band, or past the last one on a viewport tall enough that
     the midpoint clears every section. */
  return null;
}

/* The convention: a dark band says so with `.dark`. Sections get it from the
   styling they need; the footer carries it as a marker as well as for its own
   ground, so the rails invert over it. */
export function useSurface() {
  const isDark = ref(true);

  /* Called from the component's own throttled scroll handler, so a page that
     needs more than the band on each scroll keeps one listener rather than
     two. */
  const syncSurface = () => {
    const surface = surfaceAtViewportMidpoint();

    if (surface) {
      isDark.value = surface.classList.contains('dark');
    }
  };

  return { isDark, syncSurface };
}
